module.exports = __webpack_public_path__ + "img/three.a3220261.svg";